export enum OrderType {
  DELIVERY = 601,
  PICKUP = 602,
  DINEIN = 603,
  GIFTCARD = 614,
}

// Function to get enum key by value
export const getOrderTypeName = (
  value: number,
  enumObject: any,
): string | undefined => {
  return Object.keys(enumObject).find((key) => enumObject[key] == value);
};
